import { combineReducers } from "redux";
import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const decksFetchingReducer = (state = false, action) => {
  switch (action.type) {
    case types.FETCH_DECKS_REQUEST:
    case types.CREATE_DECK_REQUEST:
    case types.DUPLICATE_DECK_REQUEST:
      return true;
    case types.FETCH_DECKS_SUCCESS:
    case types.DUPLICATE_DECK_SUCCESS:
    case types.CREATE_DECK_SUCCESS:
      return false;
    default:
      return state;
  }
};

const decksAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_DECKS_SUCCESS:
      return action.data.result;
    case types.FETCH_DECK_SUCCESS:
    case types.DUPLICATE_DECK_SUCCESS:
    case types.CREATE_DECK_SUCCESS:
    case types.UPDATE_DECK_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [action.data.result, ...state]
        : state;
    case types.DELETE_DECK_SUCCESS:
      return state.filter(id => id !== action.deckId);
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const decksByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_DECKS_SUCCESS:
      return action.data.entities.decks;
    case types.FETCH_DECK_REQUEST:
    case types.UPDATE_DECK_REQUEST:
    case types.DELETE_DECK_REQUEST:
    case types.CREATE_CARD_REQUEST:
      return {
        ...state,
        [action.deckId]: { ...state[action.deckId], isFetching: true }
      };
    case types.FETCH_DECK_SUCCESS:
    case types.DUPLICATE_DECK_SUCCESS:
    case types.CREATE_DECK_SUCCESS:
    case types.UPDATE_DECK_SUCCESS:
      return { ...state, ...action.data.entities.decks };
    case types.DELETE_DECK_SUCCESS:
      const newById = state;
      delete newById[action.deckId];
      return newById;
    case types.DELETE_CARD_SUCCESS:
      const deckId = action.card.deckUUID;
      // TODO once we have cardUUID in the proficiency response we need to remove this card's proficiency
      return {
        ...state,
        [deckId]: {
          ...state[deckId],
          card_count: state[deckId].cards.length - 1,
          cards: state[deckId].cards.filter(
            cardId => cardId !== action.card.uuid
          )
        }
      };
    case types.CREATE_CARD_SUCCESS:
      const card = action.data.entities.cards[action.data.result];
      return {
        ...state,
        [card.deckUUID]: {
          ...state[card.deckUUID],
          isFetching: false,
          card_count: state[card.deckUUID].cards
            ? state[card.deckUUID].cards.length + 1
            : 1,
          cards: [card.uuid, ...state[card.deckUUID].cards]
        }
      };
    case types.CREATE_PROFICIENCY_SUCCESS:
      // TODO once we have cardUUID in the proficiency response
      return state;
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const decksReducer = combineReducers({
  isFetching: decksFetchingReducer,
  all: decksAllReducer,
  byId: decksByIdReducer
});

const cardsAllReducer = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_CARD_SUCCESS:
    case types.CREATE_CARD_SUCCESS:
    case types.UPDATE_CARD_SUCCESS:
      return state.indexOf(action.data.result) === -1
        ? [action.data.result, ...state]
        : state;
    case types.FETCH_DECK_SUCCESS:
    case types.DUPLICATE_DECK_SUCCESS:
    case types.CREATE_DECK_SUCCESS:
    case types.UPDATE_DECK_SUCCESS:
      const cards = action.data.entities.cards || {};
      return [...state, ...Object.keys(cards)];
    case types.DELETE_CARD_SUCCESS:
      return state.filter(id => id !== action.card.uuid);
    case USER_SIGNED_OUT:
      return [];
    default:
      return state;
  }
};

const cardsByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case types.FETCH_CARD_REQUEST:
    case types.UPDATE_CARD_REQUEST:
    case types.DELETE_CARD_REQUEST:
      return {
        ...state,
        [action.cardId]: { ...state[action.cardId], isFetching: true }
      };
    case types.FETCH_CARD_SUCCESS:
    case types.CREATE_CARD_SUCCESS:
    case types.UPDATE_CARD_SUCCESS:
      return { ...state, ...action.data.entities.cards };
    case types.FETCH_DECK_SUCCESS:
    case types.DUPLICATE_DECK_SUCCESS:
    case types.CREATE_DECK_SUCCESS:
    case types.UPDATE_DECK_SUCCESS:
      const cards = action.data.entities.cards || {};
      return { ...state, ...cards };
    case types.DELETE_CARD_SUCCESS:
      const newById = state;
      delete newById[action.card.uuid];
      return newById;
    case types.CREATE_PROFICIENCY_SUCCESS:
      return {
        ...state,
        [action.cardId]: {
          ...state[action.cardId],
          proficiencies: [
            action.proficiency,
            ...state[action.cardId].proficiencies
          ]
        }
      };
    case USER_SIGNED_OUT:
      return {};
    default:
      return state;
  }
};

const cardsReducer = combineReducers({
  all: cardsAllReducer,
  byId: cardsByIdReducer
});

const overleafReducer = combineReducers({
  decks: decksReducer,
  cards: cardsReducer
});

export default overleafReducer;
